module.exports = __webpack_public_path__ + "static/media/Apollios.35015172.png";